import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)
export default new Vuex.Store({
 state: {
   status: '',
   token: localStorage.getItem('token') || '',
   user: localStorage.getItem('user') || '',
 },
 mutations: {
   auth_request(state) {
     state.status = 'loading'
   },
   auth_success(state, {token, user}) {
     state.status = 'success'
     state.token = token
     state.user = user
   },
   auth_error(state) {
     state.status = 'error'
   },
   auth_update(state, user) {
     state.user = user
   },
   logout(state) {
     state.status = ''
     state.token = ''
     state.user = ''
   }
 },
 actions: {
   login({ commit }, user) {
     return new Promise((resolve, reject) => {
       commit('auth_request')
       axios({ method: 'POST', url: process.env.API_ROOT+'auth/admin/login', data: user })
        .then(resp => {
          const token = resp.data.data.token
          const user = resp.data.data.user
          localStorage.setItem('token', token)
          localStorage.setItem('user', user)
          axios.defaults.headers.common['Authorization'] = 'Bearer ' +token
          commit('auth_success', {token, user})
          resolve(resp)
        })
        .catch(err => {
          commit('auth_error')
          localStorage.removeItem('token')
          localStorage.removeItem('user')
          reject(err)
        })
     })
   },
   logout({ commit }) {
     return new Promise((resolve, reject) => {
       commit('logout')
       localStorage.removeItem('token')
       localStorage.removeItem('user')
       delete axios.defaults.headers.common['Authorization']
       resolve()
     })
   },
   register({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({ method: 'POST', url: process.env.API_ROOT+'auth/admin/register', data: user})
          .then(resp => {
            console.log(resp)
            resolve(resp)
          })
          .catch(err => {
            commit('auth_error', err)
            reject(err)
          })
      })
    },
    updateUser({ commit }, user){
      return new Promise((resolve, reject) => {
        commit('auth_update', user)
        localStorage.setItem('user', user)
        resolve()
      })
    },
 },
 getters: {
   isLoggedIn: state => !!state.token,
   authStatus: state => state.status,
   authUser: state => state.user,
 }
})



// WEBPACK FOOTER //
// ./src/store.js